import React from 'react';
import {
    TableWrapper,
    TableTitle,
    StyledTableContainer,
    StyledTable,
    StyledTableHead,
    StyledTableBody,
    StyledTableRow,
    StyledTableHeaderCell,
    StyledTableCell,
} from './style';

const HousingTable = ({ data, title }) => {
    if (!data || !title) return null;

    return (
        <TableWrapper>
            <TableTitle>{title}</TableTitle>
            <StyledTableContainer>
                <StyledTable>
                    <StyledTableHead>
                        <StyledTableRow>
                            <StyledTableHeaderCell>연월</StyledTableHeaderCell>
                            {
                                data.seriesOptions.map((data, index) => (
                                    <StyledTableHeaderCell key={index} align="right">{data.name}&#40;{data.unit}&#41;</StyledTableHeaderCell>
                                ))
                            }
                        </StyledTableRow>
                    </StyledTableHead>
                    <StyledTableBody>
                        {data.chartData.map((row, index) => (
                            <StyledTableRow key={index}>
                                <StyledTableCell fontWeight="medium">{row.ymd.substr(0, 4)}년 {row.ymd.substr(4, 5)}월</StyledTableCell>
                                {data.seriesOptions.map((option, index) => (
                                    <StyledTableCell key={index} align="right">{row[option.key].toLocaleString()}</StyledTableCell>
                                ))}
                            </StyledTableRow>
                        ))}
                    </StyledTableBody>
                </StyledTable>
            </StyledTableContainer>
        </TableWrapper>
    );
};

export default HousingTable;
